import { EnterpriseDashboardBudgetChartData } from './enterprise-dashboard-budget-chart-data';

export class EnterpriseDashboardBudgetStats {
	public budgetMetrics: {
		actualCost: number;
		currentBudgetCost: number;
		underBudgetPercent: number;
		monthlyActualCost: number;
		monthOverMonthChangePercent: number;
	};
	public budgetChartData: EnterpriseDashboardBudgetChartData[];

	public contracts: {
		originContractId: string;
		dbaName: string;
	}[];

	constructor(enterpriseDashboardBudgetStats?: EnterpriseDashboardBudgetStats) {
		Object.assign(this, enterpriseDashboardBudgetStats);
	}
}
